import type { ReactNode } from 'react';

export const symbol_game_button_l: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M80-220v-426q0-63.53 44.5-108.76Q169-800 233-800h494q64 0 108.5 45.24Q880-709.53 880-646v426q0 24.75-17.62 42.37Q844.75-160 820-160H140q-24.75 0-42.37-17.63Q80-195.25 80-220Zm60 0h680v-426q0-38.78-27-66.39T727-740H233q-39 0-66 27.61T140-646v426Zm0 0h680-680Zm334-165v-209.59q0-11.41-7-18.41t-18-7q-11 0-18 7t-7 18v226q0 12.75 8.63 21.37Q441.25-339 454-339h120q9.73 0 16.37-6.69 6.63-6.69 6.63-16.5 0-9.81-6.63-16.31-6.64-6.5-16.37-6.5H474Z"
		/>
	</svg>
);
